import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { CALL_FETCH_DOCUMENTS, fetchDocumentsFailed, fetchDocumentsSuccess, FETCH_DOCUMENTS_SUCCESS, VIEW_DOCUMENT } from '../ducks/DocumentsDucks';
import DocumentsAPI from '../integrations/DocumentsAPI';
import store from '../store';
import { resize } from '../ducks/ApplicationDucks';

function* fetchDocuments({ workflowInstanceId }) {
  try {
    const state = store.getState();
    const relatedDocuments = state.application.relatedDocuments;
    const documents = yield call(DocumentsAPI.fetchDocuments, workflowInstanceId, relatedDocuments);
    yield put(fetchDocumentsSuccess(documents));
  }
  catch(error) {
    yield put(fetchDocumentsFailed(error));
  }
}

function* fetchDocumentsSuccessSaga() {
  yield put(resize());
}

function viewDocument(action) {
  if (window.parent) {
    window.parent.postMessage(action, '*');
  }
}

function* fetchDocumentsSagas() {
  yield takeLatest(CALL_FETCH_DOCUMENTS, fetchDocuments);
}

function* fetchDocumentsSuccessSagas() {
  yield takeEvery(FETCH_DOCUMENTS_SUCCESS, fetchDocumentsSuccessSaga);
}

function* viewDocumentSagas() {
  yield takeEvery(VIEW_DOCUMENT, viewDocument);
}

export default function* () {
  yield all([
    fork(fetchDocumentsSagas),
    fork(fetchDocumentsSuccessSagas),
    fork(viewDocumentSagas)
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/DocumentsSagas.js